import { FC, Fragment } from "react";
import { CopyBlock, monokaiSublime as theme } from "react-code-blocks";

interface ShowCodeBlockProps {
  text: string,
  languageType?: string
}

const ShowCodeBlock: FC<ShowCodeBlockProps> = ({ text, languageType }) => {

  return (
    <Fragment>
      {text && <CopyBlock
        text={text}
        language={languageType || "javascript"}
        showLineNumbers={true}
        theme={theme}
        wrapLongLines={true}

      />}
    </Fragment>
  );
};

export default ShowCodeBlock;
